// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SingleBoxLayout_wrapper__3vjGp","body":"SingleBoxLayout_body__3IM-4","header":"SingleBoxLayout_header__1ZXQa","content":"SingleBoxLayout_content__1TV4J"};